"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

const {
  acos,
  sin,
  cos
} = Math;

class Geolocation {
  constructor() {
    _defineProperty(this, "latitude", null);

    _defineProperty(this, "longitude", null);
  }

  get lat() {
    return this.latitude;
  }

  set lat(value) {
    this.latitude = value;
  }

  get lon() {
    return this.longitude;
  }

  set lon(value) {
    this.longitude = value;
  } // Retorno em metros
  // From: https://www.codexworld.com/distance-between-two-addresses-google-maps-api-php


  static calculateDistance(from, to) {
    // const => (acos(dist) / rad) * 60 * 1853.159616;
    // const => (acos(dist) * 60 * 1853.159616) / rad;
    // const => (acos(dist) * 60 * 1853.159616)/ (M_PI / 180);
    // const => (acos(dist) * 6370693.4856532)
    return acos(sin(from.latitude * 0.017453292519943) * sin(to.latitude * 0.017453292519943) + cos(from.latitude * 0.017453292519943) * cos(to.latitude * 0.017453292519943) * cos((from.longitude - to.longitude) * 0.017453292519943)) * 6370693.4856531;
  }

  distanceTo(to) {
    return Geolocation.calculateDistance(this, to);
  }

  static fromObject(object) {
    let g = new Geolocation();
    Object.keys(object || {}).forEach(key => {
      let value = object[key];

      switch (key) {
        case 'lat':
        case 'latitude':
          g.latitude = value;
          g.lat = value;
          break;

        case 'lon':
        case 'longitude':
          g.longitude = value;
          g.lon = value;
          break;
      }
    });
    return g;
  }

}

exports.default = Geolocation;